import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Outlet, useNavigate } from 'react-router-dom'
import NotFound from '../pages/NotFound'
import {
    RegisterScreen,
    HomeScreen,
    SelectionScreen,
    PolicyScreen,
    PaymentScreen,
    RegistrationSuccess,
    ContactScreen,
    ErrorScreen,
    ServiceEndedScreen
} from '../pages'
import PrivateRoutes from './PrivateRoutes'
import PendingScreen from '../pages/PaymentScreen/Pending/PendingScreen'
import { getCompanyCodeParam } from '../contexts/functions'
import { COMPANY_CODES } from '../constants/configCompany'

function CompanyCheckWrapper({ children }) {
    const navigate = useNavigate()
    
    useEffect(() => {
        const companyCode = getCompanyCodeParam()
        if (companyCode === COMPANY_CODES.MARUETSU || companyCode === COMPANY_CODES.MAX_VALUE) {
            navigate(`/service-ended?company_code=${companyCode}`)
        }
    }, [navigate])
    
    return children
}

function AppRouter() {
    return (
        <BrowserRouter>
            <CompanyCheckWrapper>
                <Routes>
                    <Route path='/' element={<Outlet />}>
                        <Route index element={<RegisterScreen />} />

                        <Route path='/' element={<PrivateRoutes />}>
                            <Route path='/contact' element={<ContactScreen />} />
                            <Route path='/member-info' element={<Outlet />}>
                                <Route index element={<HomeScreen />} />
                                <Route path='/member-info/selection' element={<SelectionScreen />} />
                                <Route path='/member-info/policy' element={<PolicyScreen />} />
                                <Route path='/member-info/payment' element={<PaymentScreen />}/>
                            </Route>
                        </Route>

                        <Route path='/pending' element={<PendingScreen />} />
                        <Route path='/success' element={<RegistrationSuccess />}/>
                        <Route path="/error" element={<ErrorScreen />} />
                        <Route path="/service-ended" element={<ServiceEndedScreen />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </CompanyCheckWrapper>
        </BrowserRouter>
    )
}

export default AppRouter